import request from '@/axios'
import { convertToQueryString } from '@/utils/utils.js'

export default {

	//查询发票订单
	getTest: (data) => {
		return request({
			method: 'POST',
			url: "app/index.php?i=3&c=entry&m=tvp_appcenter&do=json&sjk=caselist" + convertToQueryString(data),
			data,
		})
	},
	register: (params) => {
		return request({
			method: 'get',
			url: "/app/index.php?i=3&c=entry&m=tvp_appcenter&do=api_reg",
			params,
		})
	},

	funk: (params) => {
		return request({
			method: 'get',
			url: "/app/index.php?i=3&c=entry&m=tvp_appcenter",
			params,
		})
	},
}
